<template>
    <div id="view-Box-3D">
        <ul class="box-type">
            <li :class="box_type === 'box' && 'active'" @click="box_type = 'box'"><i class="bi-box-seam"></i> {{ $t('views.inventory.modals.productDetail.detail.columns2.box') }}</li>
            <li :class="box_type === 'frame' && 'active'" @click="box_type = 'frame'"><i class="bi-window-sidebar"></i> {{ $t('views.inventory.modals.productDetail.detail.columns2.frame') }}</li>
        </ul>

        <div class="container" :class="box_type">
            <div class="cube">
                <div class="face front">
                    <div class="measure position-y">{{ box_dimension.y }}"</div>
                    <div class="measure">{{ box_dimension.x }}"</div>
                    <div v-if="params && params.lbs && isInteger(params.lbs)" class="lbs">{{ params.lbs.toFixed(2) }} LBS</div>
                    <div v-else-if="params && params.lbs" class="lbs">{{ params.lbs }} LBS</div>
                </div>
                <div class="face back"></div>
                <div class="face right">
                    <div class="measure">{{ box_dimension.z }}"</div>
                    <img class="depot-logo" src="@/assets/img/buyshipping-logo.svg" />
                </div>
                <div class="face left"></div>
                <div class="face top"></div>
                <div class="face bottom"></div>
                <div class="face bottom shadow"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Box3D',
    props: ['params'],
    data() {
        return {
            box_type: 'box',
            box_dimension: {
                z: 0,
                x: 0,
                y: 0,
            },
            box_container: {
                face: {},
            },
        }
    },
    methods: {
        initBox() {
            const element = document.getElementsByClassName('cube')[0]
            let lastMouseX = 0,
                lastMouseY = 0
            let rotX = 20,
                rotY = 40

            document.addEventListener('mousedown', function (ev) {
                lastMouseX = ev.clientX
                lastMouseY = ev.clientY
                document.addEventListener('mousemove', mouseMoved)
            })
            document.addEventListener('mouseup', function () {
                document.removeEventListener('mousemove', mouseMoved)
            })

            function mouseMoved(ev) {
                let deltaX = ev.clientX - lastMouseX
                let deltaY = ev.clientY - lastMouseY

                lastMouseX = ev.clientX
                lastMouseY = ev.clientY

                rotY -= deltaX * 0.4
                rotX += deltaY * 0.4

                element.style.transform = 'rotateX(' + -rotX + 'deg) rotateY(' + -rotY + 'deg)'
            }
        },

        dimensionSort() {
            const dimension = JSON.parse(JSON.stringify(this.params.dimension))
            delete dimension.weight
            delete dimension.lbs

            const sort_array = []
            Object.keys(dimension).forEach((name) => {
                sort_array.push(dimension[name])
            })
            sort_array.sort(function (a, b) {
                return b - a
            })

            // this.box_dimension.z = sort_array[0];
            // this.box_dimension.x = sort_array[1];
            // this.box_dimension.y = sort_array[2];

            this.box_dimension.z = dimension.length
            this.box_dimension.x = dimension.width
            this.box_dimension.y = dimension.height

            this.generateBox()
        },

        generateBox() {
            const _d = JSON.parse(JSON.stringify(this.box_dimension))
            const item_size = _d.x + _d.y + _d.z * 2
            let screen_size = 1
            let multiplier = 15

            if (item_size < 20) {
                screen_size = Math.abs((100 - item_size) / 100)
                screen_size = screen_size < 1 ? screen_size + 1 : screen_size
            } else if (item_size > 75) {
                if (_d.z > 30) multiplier = multiplier - (item_size / 100) * 4
                screen_size = Math.abs((100 - item_size) / 100)
                screen_size = screen_size < 1 ? 1 - screen_size : screen_size
            }

            Object.keys(_d).forEach((item) => {
                _d[item] = _d[item] * multiplier * Math.abs(screen_size)
            })

            // Container Style
            this.box_container.el = document.querySelectorAll('#view-Box-3D .container')[0]
            this.box_container.width = _d.x
            this.box_container.height = _d.y
            this.box_container.el.style.width = this.box_container.width + 'px'
            this.box_container.el.style.height = this.box_container.height + 'px'

            if (_d.z >= 200 || _d.y >= 200 || _d.x >= 200) {
                Object.keys(_d).forEach((key) => {
                    _d[key] = _d[key] / 1.4
                })
            }

            // Face Top
            this.box_container.face.top = {
                width: _d.x,
                height: _d.z,
                transform: 'rotateX(90deg) translateZ(' + (_d.z - _d.y / 2 - (_d.z - _d.y) / 2) + 'px)',
            }

            // Face Bottom
            this.box_container.face.bottom = {
                width: _d.x,
                height: _d.z,
                transform: 'rotateX(-90deg) translateZ(' + (_d.z / 2 - (_d.z - _d.y)) + 'px)',
            }

            // Face Right
            this.box_container.face.right = {
                width: _d.z,
                height: _d.y,
                transform: 'rotateY(90deg) translateZ(' + (_d.x - _d.y / 2 + (_d.y - _d.z) / 2) + 'px)',
            }

            // Face Left
            this.box_container.face.left = {
                width: _d.z,
                height: _d.y,
                transform: 'rotateY(-90deg) translateZ(' + (_d.y / 2 - (_d.y - _d.z) / 2) + 'px)',
            }

            // Face Front
            this.box_container.face.front = {
                width: _d.x,
                height: _d.y,
                transform: 'rotateX(0deg) translateZ(' + _d.z / 2 + 'px)',
            }

            // Face Back
            this.box_container.face.back = {
                width: _d.x,
                height: _d.y,
                transform: 'rotateX(-180deg) translateZ(' + _d.z / 2 + 'px)',
            }

            // Face Bottom
            this.box_container.face.shadow = {
                width: _d.x,
                height: _d.z,
                transform: 'rotateX(-90deg) translateZ(' + (_d.z / 2 - (_d.z - _d.y)) + 'px)',
            }

            const _this = this
            Object.keys(_this.box_container.face).forEach((face_name) => {
                const selector = '#view-Box-3D .face.' + face_name
                const el = document.querySelectorAll(selector)[0]

                Object.keys(_this.box_container.face[face_name]).forEach((style_name) => {
                    if (style_name === 'transform') {
                        el.style[style_name] = _this.box_container.face[face_name][style_name]
                    } else {
                        el.style[style_name] = _this.box_container.face[face_name][style_name] + 'px'
                    }
                })
            })
        },

        isInteger(value) {
            const numericValue = parseFloat(value)
            return Number.isInteger(numericValue)
        },
    },
    created() {
        setTimeout(() => {
            this.dimensionSort()
            this.initBox()
        }, 150)
    },
}
</script>

<style scoped lang="scss">
$z: 75px;
$x: 75px;
$y: 75px;

#view-Box-3D {
    padding: 50px;
    text-align: center;
    position: relative;
    overflow: hidden;

    ul.box-type {
        position: absolute;
        right: 5px;
        top: 5px;

        li {
            display: inline-block;
            padding: 4px 8px;
            font-weight: normal;
            cursor: pointer;

            color: #00203f;
            font-size: 12px;

            i {
                margin-right: 5px;
            }

            &.active {
                background: #bdc5d133;
                color: #00203f;
                border-radius: 8px;
            }
        }
    }
}

.container {
    user-select: none;
    perspective: 1000px;
    padding: 0;
    margin: 30px;
    display: inline-block;

    .cube {
        transform-style: preserve-3d;
        width: 100%;
        height: 100%;
        position: relative;
        transform: rotateX(-20deg) rotateY(-40deg);

        .face {
            position: absolute;
            width: 100%;
            height: 100%;
            cursor: pointer;
            background: url('@/assets/img/box-texture.jpg');
            background-size: contain;

            &.shadow {
                position: fixed;
                background: #000;
                top: 30px;
                opacity: 0.2;
                filter: blur(8px);
            }

            .measure {
                display: none;
            }

            .lbs {
                font-size: 13px;
                font-weight: 500;
                color: #000;
                text-align: right;
                padding: 5px;
                position: relative;
            }

            img {
                width: 50%;
                position: absolute;
                bottom: 10%;
                right: 10%;
                pointer-events: none;

                &.depot-logo {
                    filter: brightness(0);
                    width: 50%;
                    height: 50%;
                    max-width: 200px;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    top: 50%;
                    margin: auto;
                    transform: translateY(-35%);
                    opacity: 0.8;
                }
            }

            &.top {
                box-shadow: inset 0 0 0 500px #ffffff15;
                background: url('@/assets/img/amazon-box-texture.jpg');
                background-size: contain;
            }

            &.bottom {
                box-shadow: inset 0 0 0 500px #00000060;
            }

            &.front {
                box-shadow: inset 0 0 0 500px #00000030;

                &:before {
                    position: absolute;
                    z-index: 0;
                    content: '';
                    width: 100%;
                    height: 20%;
                    min-height: 8px;
                    display: block;
                    box-shadow: inset 0 0 0 500px #00000030;
                    background: url('@/assets/img/amazon-box-texture.jpg');
                    background-size: cover;
                    top: 0;
                }
            }

            &.back {
                box-shadow: inset 0 0 0 500px #00000030;

                &:before {
                    position: absolute;
                    z-index: 0;
                    content: '';
                    width: 100%;
                    height: 20%;
                    min-height: 8px;
                    display: block;
                    box-shadow: inset 0 0 0 500px #00000030;
                    background: url('@/assets/img/amazon-box-texture.jpg');
                    background-size: cover;
                    bottom: 0;
                }
            }
        }
    }

    &.frame {
        .cube .face {
            background: none;
            border: solid 1px #1a4398;
            box-shadow: inset 0 0 0 500px #2196f31c;

            .measure {
                color: #113580;
                border-top: solid 1px #113580;
                padding: 5px 15px;
                display: inline-block;
                position: absolute;
                bottom: -10px;
                left: 10%;
                right: 10%;
                transform: translateY(100%);

                &:after {
                    content: '';
                    width: 9px;
                    height: 9px;
                    border-right: solid 1px #113580;
                    border-top: solid 1px #113580;
                    display: block;
                    position: absolute;
                    right: -3px;
                    transform: rotate(45deg);
                    top: -5px;
                }

                &:before {
                    content: '';
                    width: 9px;
                    height: 9px;
                    border-left: solid 1px #113580;
                    border-top: solid 1px #113580;
                    display: block;
                    position: absolute;
                    left: -3px;
                    transform: rotate(-45deg);
                    top: -5px;
                }

                &.position-y {
                    border: none;
                    border-right: solid 1px #113580;
                    left: -10px;
                    right: initial;
                    top: 10%;
                    bottom: 10%;
                    transform: translateX(-100%);
                    display: flex;
                    align-items: center;

                    &:before {
                        top: -5px;
                        transform: rotate(45deg);
                        right: -5px;
                        left: initial;
                    }

                    &:after {
                        top: initial;
                        bottom: -5px;
                        transform: rotate(135deg);
                        right: -5px;
                    }
                }
            }

            &.shadow {
                display: none;
            }

            &.front,
            &.back {
                &:before,
                &:after {
                    display: none;
                }
            }

            img {
                display: none;
            }
        }
    }
}
</style>
